export default __webpack_public_path__ + "static/media/sun.c703bba4.svg";